// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"2da47776","498":"d82bd85a","703":"41dc47e7"}[chunkId] + ".chunk.js";
};